import * as React from 'react';
import { FavouriteReplaceDomainNodes, FavouriteDefinition, AdminInfoData } from 'app/types-shared';
import { FiltersDrawer } from 'app/area/filters/filters-drawer';
import { CreateReport } from '../../saved-reports';
import styles from './favourite.scss';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { ReactNode, useEffect } from 'react';

interface FavouriteLayoutContainerProps {
  definition: FavouriteDefinition;
  workingDefinition: FavouriteDefinition;
  translation: any;
  isCreateReportOpen: boolean;
  hideFilterReplacements?: boolean;
  adminPanelAccess?: AdminInfoData;
  updateExistingReport: boolean;
  initiallyOpenFilter: boolean;
  closeReportCreator: () => void;
  updateDefinition: (transform?: (definition: FavouriteDefinition) => FavouriteDefinition) => void;
  fetchingUpdateReplaceDomainNodes?: boolean;
  fetchingExtendedReplaceDomainNodes?: boolean;
  updateReplaceDomainNodes: (transform: (definition: FavouriteDefinition) => FavouriteDefinition, onSuccess: () => void) => void;
  loadExtendedReplaceDomainNodes: (favouriteId: number, onSuccess: (replaceDomainNodes: FavouriteReplaceDomainNodes[]) => void) => void;
  searchRequiredUsers: boolean;
  hideFilters: boolean;
  getSearchRequiredUsers: () => void;
  children: ReactNode;
}

export function FavouriteLayout({
  getSearchRequiredUsers,
  definition, workingDefinition, translation, children, updateDefinition, adminPanelAccess,
  updateReplaceDomainNodes, loadExtendedReplaceDomainNodes, closeReportCreator, isCreateReportOpen, hideFilterReplacements,
  updateExistingReport, initiallyOpenFilter, searchRequiredUsers, hideFilters,
  fetchingUpdateReplaceDomainNodes, fetchingExtendedReplaceDomainNodes
}: FavouriteLayoutContainerProps) {

  useEffect(() => {
    getSearchRequiredUsers?.();
  }, []);

  return <MainGridContainer className={styles.searchResults}>
    {isCreateReportOpen && <CreateReport
      closeReportCreator={closeReportCreator}
      definition={definition}
      searchRequiredUsers={searchRequiredUsers}
      updateReport={updateExistingReport}
    />}
    {hideFilters ? children : <div className={styles.drawerWithBar}>
      <FiltersDrawer
        title={translation.filters_title}
        updateDefinition={updateDefinition}
        fetchingUpdateReplaceDomainNodes={fetchingUpdateReplaceDomainNodes}
        fetchingExtendedReplaceDomainNodes={fetchingExtendedReplaceDomainNodes}
        updateReplaceDomainNodes={updateReplaceDomainNodes}
        loadExtendedReplaceDomainNodes={loadExtendedReplaceDomainNodes}
        definition={definition}
        workingDefinition={workingDefinition}
        initiallyOpen={initiallyOpenFilter}
        hideFilterReplacements={hideFilterReplacements}
        adminPanelAccess={adminPanelAccess}>
        {children}
      </FiltersDrawer>
    </div>}
  </MainGridContainer>;
}
